"use strict";
export const VDTopMock = (mock) => {
  mock.onPost(/\/v1\/virtual-desktops\/(\d+)\/top/).reply((cofig) => {
    let _response = {};
    return [200, _response];
  });
  mock.onDelete(/\/v1\/virtual-desktops\/(\d+)\/top/).reply((config) => {
    let _response = {};
    return [200, _response];
  });
};
